module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lp-wrapper"
  }, [_vm._t("reasontype", [_c('p', {
    staticClass: "radio-group"
  }, [_vm._v("落地页优化筛选："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason.currentReason),
      expression: "reason.currentReason"
    }],
    attrs: {
      "name": 'reason',
      "options": _vm.reason.reasonList
    },
    domProps: {
      "value": (_vm.reason.currentReason)
    },
    on: {
      "input": function($event) {
        _vm.reason.currentReason = $event
      }
    }
  })], 1), _vm._m(0)], {
    reason: _vm.reason
  }), _c('div', {
    staticClass: "advice-table lp-opt-table"
  }, [_c('HeadFixedTable', {
    attrs: {
      "columns": _vm.currentColumns,
      "checkbox": _vm.hasCheckbox,
      "check_all": _vm.hasCheckbox,
      "checkbox_length": 9000,
      "hasPagination": true,
      "list": _vm.currentList
    },
    scopedSlots: {
      "delete-td": function(props) {
        return [_vm._t("delete", null, {
          item: props.item
        })]
      },
      "status-td": function(props) {
        return [_vm._t("status", null, {
          item: props.item
        })]
      }
    }
  })], 1)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-tip"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("说明：")]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v(" 1、 跳出率高的页面，请查看页面与搜索意图是否匹配，或者使用“热力图”功能对页面进行深入分析")]), _c('p', [_vm._v(" 2、其他转化率较低页面，可能由到达率低或者其他原因导致，请配合使用“路径分析”功能查看用户主要流失步骤")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3710e890", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3710e890!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/lp_advice_table.vue
// module id = 737
// module chunks = 0